import React from "react";
import {useField, useFormikContext} from "formik";
import NumberFormat from 'react-number-format';


export function EnergiaFormatacao(
    cellContent,
    row,
    rowIndex
) {

    return (
        <>
            <NumberFormat thousandSeparator={true} suffix={' kWh'}
                          displayType={'text'}
                          decimalSeparator="."
                          thousandSeparator=","
                          value={cellContent}
            />
        </>
    );
}
